/*
 * We use "lgu-*" ("legacy unit") prefix for legacy size variants
 * (prefix chosen to be both short and easily greppable).
 * The app used to have rem set to 10px, making tailwind's 1/4 fractions of rem subpixel.
 * To migrate to rem=16px and avoid restyling whole app, we introduced these prefixes for legacy styles.
 * PLEASE DON'T USE THESE LEGACY VARIANTS IN NEW CODE/COMPONENTS.
 * Feel free to remove each legacy variant when it is not used anymore.
 */

import containerQueries from '@tailwindcss/container-queries';
import type { Config } from 'tailwindcss';
import plugin from 'tailwindcss/plugin';
import { ipfTheme } from './ipfTailwindTheme';

const customUtilitiesPlugin = plugin(({ addUtilities }) => {
  addUtilities({
    '.match-parent': {
      position: 'absolute',
      inset: '0',
    },
  });
});

export const tailwindConfigBase = {
  content: [],
  darkMode: 'selector',
  prefix: '',
  important: false,
  separator: ':',
  theme: ipfTheme,
  plugins: [containerQueries, customUtilitiesPlugin],
  corePlugins: {
    // Preflight CSS is disabled for direct control over style imports and correct order of css rules.
    // Import /public/tailwind/css/preflight.min.css first in projects using shared-assets for correct CSS rule order.
    preflight: false,
  },
  // Add .dark class to safelist for dynamic theme switching via storybook addon.
  safelist: ['dark'],
} satisfies Config;
